var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclularCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 31.08C11.5439 31.08 5.91992 25.456 5.91992 18.5C5.91992 11.544 11.5439 5.91998 18.4999 5.91998C25.4559 5.91998 31.0799 11.544 31.0799 18.5C31.0799 25.456 25.4559 31.08 18.4999 31.08ZM18.4999 7.39998C12.3579 7.39998 7.39992 12.358 7.39992 18.5C7.39992 24.642 12.3579 29.6 18.4999 29.6C24.6419 29.6 29.5999 24.642 29.5999 18.5C29.5999 12.358 24.6419 7.39998 18.4999 7.39998Z",
    fill: "#989797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.02 23.976L10.582 17.538L11.618 16.502L17.02 21.904L25.382 13.542L26.418 14.578L17.02 23.976Z",
    fill: "#989797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclularCheck);
export default __webpack_public_path__ + "static/media/circlular-check.1dbeca234da5ebc12e0fe2b7d836604b.svg";
export { ForwardRef as ReactComponent };